module.exports = __webpack_public_path__ + "static/scale-model-of-uss-kidd-museum-in-baton-rouge-louisiana-2c2d6774c58eb0b173f30b6cad886ff2.png";